<template>
  <div id="download-video-popup" class="modal modal-position fade" role="dialog" data-backdrop="false">
    <div class="modal-dialog modal-lg modal-dialog-own" role="downloadVideoModal">
      <div class="modal-content p-0">
        <div class="modal-body p-0">
          <div class="row">
            <div class="description">
              You are downloading a file that may have Personally Identifiable Information (PII) and are solely responsible for it’s privacy.
            </div>
          </div>
          <div class="row download-modal pt-24 pb-40 text-center">
            <div class="col-md-12 col-xl-12">
              <button class="btn br-3 btn-block m-auto mb-12 pt-10 pb-10 pl-30 pr-30 download-video-btn confirm" @click="downloadArchiveVideo('archive.mp4')">
                I Understand
              </button>
            </div>
            <div class="col-md-12 col-xl-12">
              <button class="btn add-invite-btn btn-block m-auto br-3 pt-10 pb-10 pl-45 pr-45 download-video-btn cancel" @click="cancel()">
                Cancel download
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop" @click="cancel()"></div>
  </div>
</template>
<script>
import toastr from "toastr";

export default {
  name: "downloadVideoModal",
  components: {},
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    archiveId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  mounted() {},
  watch: {
    showModal: {
      handler(val) {
        if (val) {
          window.$("#download-video-popup").modal("show");
        } else {
          window.$("#download-video-popup").modal("hide");
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    downloadArchiveVideo(filename) {
      const self = this;
      toastr.success("Your download started.");
      this.$api.getArchiveUrl(this.$route.params.studyId, this.archiveId).then(
        response => {
          const downloadUrl = response.body;
          toastr.success("Download is in progress. Please wait.");
          self.downloadFile(downloadUrl, filename);
          this.$emit("change-modal-state", false);
          window.$("#download-video-popup").modal("hide");
        },
        () => {
          toastr.error("Error in download");
        }
      );
    },
    downloadFile(dataURL, filename) {
      const oReq = new XMLHttpRequest();
      const URLToDownload = dataURL;
      oReq.open("GET", URLToDownload, true);
      oReq.responseType = "blob";
      oReq.onload = function() {
        const file = new Blob([oReq.response], {
          type: "video/mp4"
        });
        // eslint-disable-next-line no-undef
        saveAs(file, filename);
        toastr.success("Download complete");
      };
      oReq.send();
    },
    cancel() {
      this.$emit("change-modal-state", false);
      window.$("#download-video-popup").modal("hide");
    }
  }
};
</script>
<style scoped lang="scss" src="../../../public/static/fonts.scss"></style>
<style scoped lang="scss">
#download-video-popup {
  .modal-dialog {
    width: 526px;
    z-index: 99999999 !important;
    .modal-body {
      .invite-text {
        width: 100%;
        color: #666669;
        font-size: 18px;
      }
      .download-modal {
        width: 100%;
        display: inline-block;
      }
    }
  }
  .download-video-btn {
    width: 56%;
    border-radius: 100px;
    font-family: RobotoRegular;
    font-size: 14px;
    &.cancel {
      background-color: #fff !important;
      border-color: #fff !important;
      color: #4c8ce4;
    }
    &.cancel:hover {
      box-shadow: none;
      color: #4c8ce4;
    }
    &.confirm {
      background-color: #4c8ce4 !important;
      border-color: #4c8ce4 !important;
      color: #fff;
    }
  }
  .description {
    font-size: 16px;
    line-height: 1.5;
    color: #666669;
    padding: 34px 22px 4px 22px;
    text-align: center;
  }
}
.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100 !important;
  background-color: #000;
  opacity: 0.5;
}
@media screen and (min-width: 768px) {
  .modal-dialog {
    width: 526px !important; /* New width for default modal */
    min-width: 526px !important;
  }
}
</style>
